import * as Sentry from '@sentry/browser'

const COLOR_PROPERTIES = {
    'custom_background_color': '--custom-background-color',
    'custom_navbar_color': '--custom-navbar-color',
    'custom_logo_color': '--custom-logo-color',
    'custom_navbar_logo_color': '--custom-navbar-logo-color',
    'custom_text_color': '--custom-text-color',
    'custom_navbar_text_color': '--custom-navbar-text-color',
    'custom_image_decoration_color': '--custom-image-decoration-color',
    'bg_image_desktop': '--bg-image-desktop',
    'custom_border_top': '--custom-border-top',
}

export function setCustomColors(...properties) {
    const el = document.getElementById('custom-colors-data')
    if (!el || !el.textContent) return

    try {
        const customColors = JSON.parse(el.textContent)

        for (const [jsonKey, cssVar] of Object.entries(COLOR_PROPERTIES)) {
            const shouldApply = properties.length === 0 || properties.includes(jsonKey)
            const value = customColors[jsonKey]

            if (shouldApply && value) {
                document.body.style.setProperty(cssVar, value)
            }
        }
    } catch (e) {
        Sentry.captureException(e)
    }
}

export function resetCustomColors(...properties) {
    for (const [jsonKey, cssVar] of Object.entries(COLOR_PROPERTIES)) {
        const shouldReset = properties.length === 0 || properties.includes(jsonKey)
        if (shouldReset) {
            document.body.style.removeProperty(cssVar)
        }
    }
}
